module.exports = __webpack_public_path__ + "static/media/ACEProductInfo.2451224c.jpg";